export const resolveTokenStatus = (token: {
  revokedAt: Date | string | null;
  expiresAt: Date | string | null;
}): string => {
  if (token.revokedAt) return 'Revoked';
  if (token.expiresAt) {
    const expires = token.expiresAt instanceof Date ? token.expiresAt : new Date(token.expiresAt);
    if (!Number.isNaN(expires.getTime()) && expires.getTime() < Date.now()) {
      return 'Expired';
    }
  }
  return 'Active';
};

export const formatTokenDateInput = (value: Date | string | null): string => {
  if (!value) return '';
  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toISOString().slice(0, 10);
};
